import React from 'react';

import { countriesCode } from '@swf/core/utils/phoneVerification';

import type { Props as SelectProps } from '../../../Select/Select';
import Select from '../../../Select/Select';

import {
  TXTWCL_Contact_Details,
  TXTWCL_Find_your_country_code
} from './DialingCodeSelect.messages.json';
import Code from './components/Code/Code';

type Props = Partial<SelectProps>;

const DialingCodeSelect: React.FC<Props> = ({ children, disabled, fieldName, ...props }) => (
  <Select
    item={Code}
    name={fieldName}
    options={countriesCode}
    title={TXTWCL_Contact_Details}
    searchLabel={TXTWCL_Find_your_country_code}
    disabled={disabled}
    {...props}
  >
    {children}
  </Select>
);

export default DialingCodeSelect;
